import Vue from 'vue';
import Router from 'vue-router';

import {
  logout,
  isLoggedIn,
} from '@/auth';
import Login from '@/components/Login';
import ScheduleMessages from '@/components/ScheduleMessages';
import Settings from '@/components/Settings';
import Status from '@/components/Status';
import {
  isCordova,
} from '@/utils';

Vue.use(Router);

function requireAuth(to, from, next) {
  if (!isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    });
  } else {
    next();
  }
}

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    component: Status,
    beforeEnter: requireAuth,
  }, {
    path: '/login',
    component: Login,
  }, {
    path: '/logout',
    beforeEnter(to, from, next) {
      logout();
      next('/');
    },
  }, {
    path: '/settings',
    component: Settings,
    beforeEnter: (to, from, next) => {
      if (!isCordova) {
        next('/');
      } else {
        requireAuth(to, from, next);
      }
    },
  }, {
    path: '/scheduleMessages',
    component: ScheduleMessages,
    beforeEnter: (to, from, next) => {
      requireAuth(to, from, next);
    },
  }, {
    path: '*',
    beforeEnter(to, from, next) {
      next('/');
    },
  }],
});



// WEBPACK FOOTER //
// ./src/router/index.js